import type { ProjectModel } from "./ProjectModel";

/**
 * `ProjectModelAi` — partial of {@link ProjectModel} holding AI-related
 * delegate state. Port of `Models/ProjectModel/ProjectModel_AI.cs`.
 *
 * Today this is just a placeholder: the host class already owns
 * `isAIGuidePlaying` because TS getters/setters can't easily come in via
 * mixins. When `AIOrchestratorModel` lands in M11 this partial will gain
 * the orchestrator delegate plumbing (the cs file forwards to
 * `IAIOrchestratorModel.IsGuidePlaying`).
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ProjectModelAi {
  // Methods/properties added in M11. Keeping the file present now so the
  // mixin import path is stable.
  /* istanbul ignore next */
  protected static readonly _placeholder: ProjectModel | null = null;
}
